<script>

import axios from 'axios'
import laroute from './../laroute'
import trans from '../mixins/trans'
import passwordValidation from '../mixins/passwordValidation'

export default {

    props: {
        tariff: '',
        max_allowed_users: '',
        company_name: '',
        register_email: '',
        initial_payment_interval: {
            default: 'quarterly'
        },
        discounts: {},
        price_per_month: {
            type: Number,
            default: 100
        },
        price: {
            type: Number,
            default: 100
        },
        'passwordPolicyRegexp': {
            type: String,
            default: '',
        },
    },
    mounted() {
        if (window.location.hash) {
            let hash = window.location.hash.substring(1)
            if (hash === 'register') {
                $('#address-tab').removeClass('disabled');
                $('#register-tab').removeClass('disabled');
            }
            if (hash === 'check') {
                $('#address-tab').removeClass('disabled').tab('show');
                $('#register-tab').removeClass('disabled');
            }
        }

        if (this.company_name === '' && sessionStorage.companyName !== 'undefined') {
            this.companyName = sessionStorage.companyName;
        }

        if (this.register_email === '' && sessionStorage.email !== 'undefined') {
            this.email = sessionStorage.email;
        }

        sessionStorage.firstname === 'undefined' ? this.firstname = '' : this.firstname = sessionStorage.firstname
        sessionStorage.lastname === 'undefined' ? this.lastname = '' : this.lastname = sessionStorage.lastname
        sessionStorage.companyZipCode === 'undefined' ? this.companyZipCode = '' : this.companyZipCode = sessionStorage.companyZipCode
        sessionStorage.companyCity === 'undefined' ? this.companyCity = '' : this.companyCity = sessionStorage.companyCity
        sessionStorage.companyStreet === 'undefined' ? this.companyStreet = '' : this.companyStreet = sessionStorage.companyStreet
        sessionStorage.companyHouseNumber === 'undefined' ? this.companyHouseNumber = '' : this.companyHouseNumber = sessionStorage.companyHouseNumber
        sessionStorage.companyPostOfficeBox === 'undefined' ? this.companyPostOfficeBox = '' : this.companyPostOfficeBox = sessionStorage.companyPostOfficeBox
        sessionStorage.customerContactPhone === 'undefined' ? this.customerContactPhone = '' : this.customerContactPhone = sessionStorage.customerContactPhone
        sessionStorage.companyAdditionalAddress === 'undefined' ? this.companyAdditionalAddress = '' : this.companyAdditionalAddress = sessionStorage.companyAdditionalAddress
        sessionStorage.companyCountry === 'undefined' ? this.companyCountry = '' : this.companyCountry = sessionStorage.companyCountry
        sessionStorage.companyVatId === 'undefined' ? this.companyVatId = '' : this.companyVatId = sessionStorage.companyVatId
        sessionStorage.differentBillAddress === 'true' ? this.differentBillAddress = true : this.differentBillAddress = false
        sessionStorage.billAddressCompanyName === 'undefined' ? this.billAddressCompanyName = '' : this.billAddressCompanyName = sessionStorage.billAddressCompanyName
        sessionStorage.billAddressZipCode === 'undefined' ? this.billAddressZipCode = '' : this.billAddressZipCode = sessionStorage.billAddressZipCode
        sessionStorage.billAddressCity === 'undefined' ? this.billAddressCity = '' : this.billAddressCity = sessionStorage.billAddressCity
        sessionStorage.billAddressStreet === 'undefined' ? this.billAddressStreet = '' : this.billAddressStreet = sessionStorage.billAddressStreet
        sessionStorage.billAddressHouseNumber === 'undefined' ? this.billAddressHouseNumber = '' : this.billAddressHouseNumber = sessionStorage.billAddressHouseNumber
        sessionStorage.billAddressPostOfficeBox === 'undefined' ? this.billAddressPostOfficeBox = '' : this.billAddressPostOfficeBox = sessionStorage.billAddressPostOfficeBox
        sessionStorage.billAddressAdditionalAddress === 'undefined' ? this.billAddressAdditionalAddress = '' : this.billAddressAdditionalAddress = sessionStorage.billAddressAdditionalAddress
        sessionStorage.billAddressCountry === 'undefined' ? this.billAddressCountry = '' : this.billAddressCountry = sessionStorage.billAddressCountry
        sessionStorage.code === 'undefined' ? this.code = '' : this.code = sessionStorage.code
    },

    data() {
        return {
            companyName: this.company_name,
            selectedtariff: this.tariff,
            slug: '',
            companyZipCode: '',
            companyCity: '',
            companyStreet: '',
            companyHouseNumber: '',
            companyPostOfficeBox: '',
            companyAdditionalAddress: '',
            companyCountry: '',
            companyVatId: '',
            customerContactPhone: '',
            differentBillAddress: '',
            billAddressCompanyName: '',
            billAddressZipCode: '',
            billAddressCity: '',
            billAddressStreet: '',
            billAddressHouseNumber: '',
            billAddressPostOfficeBox: '',
            billAddressAdditionalAddress: '',
            billAddressCountry: '',
            firstname: '',
            lastname: '',
            email: this.register_email,
            MyPassword: '',
            payment_interval: this.initial_payment_interval,
            error_messages: [],
            email_error: 0,
            code: '',
            voucher: '',
        }
    },

    mixins: [
        passwordValidation,
        trans
    ],

    methods: {
        formatAmount(num) {
            return parseFloat(num).toFixed(2).replace(".", ",") + '€';
        },

        goCheck() {
            this.persistData()
            axios.post(laroute.route('auth.registration.checkemail'), {'email': this.email}).then((response) => {

                let self = this,
                    $form = $('#register-form'),
                    email = $form.find('#email').get(0);

                if (response.data === 'empty') {
                    this.email_error = 2;
                    email.setCustomValidity('subscriptions.registration.enter_email');
                } else if (response.data === 'existent') {
                    this.email_error = 1;
                    email.setCustomValidity('This email is already in use. Please try a different email or log in.');
                } else {
                  this.email_error = 0;
                  email.setCustomValidity('');
                }

                this.error_messages = this.checkPasswordValidity($("#password").val(), self.passwordPolicyRegexp);

                if ($form[0].checkValidity()) {
                    $('#check-tab').removeClass('disabled').trigger('click');
                    $('html, body').animate({scrollTop: '0px'}, 300);
                }

                $form.find('.input-group').removeClass('is-invalid');
                $form.addClass('was-validated').find('.input-group').has(':invalid').addClass('is-invalid');

                if (this.email_error > 0 || this.error_messages.length > 0) {
                    $('#go_register').trigger('click');
                    return 0;
                }

            });

            this.validateSlug();
        },

        validateSlug() {
            if (this.slugCompanyName !== "") {
                axios.post(laroute.route('auth.registration.checkslug'), {'slug': this.slugCompanyName})
                    .then((response) => {
                        this.slug = response.data['slug'];
                    });
            }
        },

        prefillBillingCompany() {
            if (typeof this.billAddressCompanyName === 'undefined' || this.billAddressCompanyName.length == 0) {
                this.billAddressCompanyName = this.companyName;
            }
        },

        storeRegistration() {
            let that = this;
            let form = $('#check-form');
            if (form[0].checkValidity()) {
                let postdata = {
                    firstname: this.firstname,
                    lastname: this.lastname,
                    companyName: this.companyName,
                    slug: this.slug,
                    companyZipCode: this.companyZipCode,
                    companyCity: this.companyCity,
                    companyStreet: this.companyStreet,
                    companyHouseNumber: this.companyHouseNumber,
                    companyPostOfficeBox: this.companyPostOfficeBox,
                    customerContactPhone: this.customerContactPhone,
                    companyAdditionalAddress: this.companyAdditionalAddress,
                    companyCountry: this.companyCountry,
                    companyVatId: this.companyVatId,
                    email: this.email,
                    password: $("#password").val(),
                    differentBillAddress: this.differentBillAddress,
                    billAddressCompanyName: this.billAddressCompanyName,
                    billAddressZipCode: this.billAddressZipCode,
                    billAddressCity: this.billAddressCity,
                    billAddressStreet: this.billAddressStreet,
                    billAddressHouseNumber: this.billAddressHouseNumber,
                    billAddressPostOfficeBox: this.billAddressPostOfficeBox,
                    billAddressAdditionalAddress: this.billAddressAdditionalAddress,
                    billAddressCountry: this.billAddressCountry,
                    tariff: this.selectedtariff,
                    max_allowed_users: this.max_allowed_users,
                    payment_interval: this.payment_interval,
                    code: this.code,
                };

                axios.post(laroute.route('auth.registration.store'), postdata).then(function (response) {
                    $('#confirmation-tab').removeClass('disabled').trigger('click');
                    $('html, body').animate({scrollTop: '0px'}, 300);
                    $('#address-tab').addClass('disabled');
                    $('#register-tab').addClass('disabled');
                    $('#check-tab').addClass('disabled');
                    sessionStorage.clear();
                }).then(response => {
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        'event': 'uwp-order-successfull',
                        'page': {'action': 'uwp-registration-new'},
                        'user': {'status': 'new'}
                    });
                    // use additional data node for details
                    window.dataLayer.push({
                        'subscription': {
                            'tariff': postdata.tariff,
                            'discount': that.discount+'%',
                            'max_users': postdata.max_allowed_users,
                            'price_per_month': that.discountedPrice,
                            'price_per_year': that.discountedAmount,
                            'payment_interval': postdata.payment_interval
                        }
                    });
                }).catch(function (error) {
                    //currentObj.output = error;
                });

            }
            form.addClass('was-validated')
        },

        redeemVoucher() {
            let that = this;

            axios.post(laroute.route('voucher.verify'), {
                'code': this.code,
                'tariff': this.selectedtariff,
                'payment_interval': this.payment_interval
            })
                .then(function (response) {
                    if (response.data.success) {
                        that.voucher = response.data.voucher;
                        $('#voucherModal').find('.modal-body').text('Der Gutschein ist gültig und wird mit Ihrer Bestellung eingelöst.');
                    } else {
                        that.voucher = '';
                        $('#voucherModal').find('.modal-body').text(response.data.error);
                    }
                    $('#voucherModal').modal('show')
                })
                .catch(function () {
                    that.voucher = '';
                    $('#voucherModal').find('.modal-body').text(that.__('subscriptions.voucher.validation_failed'));
                    $('#voucherModal').modal('show')
                });
        },

        removeVoucher() {
            this.voucher = '';
            this.code = '';
        },

        persistData() {
            sessionStorage.firstname = this.firstname
            sessionStorage.lastname = this.lastname
            sessionStorage.companyName = this.companyName
            sessionStorage.companyZipCode = this.companyZipCode
            sessionStorage.companyCity = this.companyCity
            sessionStorage.companyStreet = this.companyStreet
            sessionStorage.companyHouseNumber = this.companyHouseNumber
            sessionStorage.companyPostOfficeBox = this.companyPostOfficeBox
            sessionStorage.customerContactPhone = this.customerContactPhone
            sessionStorage.companyAdditionalAddress = this.companyAdditionalAddress
            sessionStorage.companyCountry = this.companyCountry
            sessionStorage.companyVatId = this.companyVatId
            sessionStorage.email = this.email
            sessionStorage.differentBillAddress = this.differentBillAddress
            sessionStorage.billAddressCompanyName = this.billAddressCompanyName
            sessionStorage.billAddressZipCode = this.billAddressZipCode
            sessionStorage.billAddressCity = this.billAddressCity
            sessionStorage.billAddressStreet = this.billAddressStreet
            sessionStorage.billAddressHouseNumber = this.billAddressHouseNumber
            sessionStorage.billAddressPostOfficeBox = this.billAddressPostOfficeBox
            sessionStorage.billAddressAdditionalAddress = this.billAddressAdditionalAddress
            sessionStorage.billAddressCountry = this.billAddressCountry
            sessionStorage.selectedtariff = this.selectedtariff
            sessionStorage.max_allowed_users = this.max_allowed_users
            sessionStorage.payment_interval = this.payment_interval
            sessionStorage.code = this.code
        },

        countryByKey(key) {
            return this.__('countries.' + key);
        }
    },

    computed: {
        slugCompanyName() {
            return this.companyName.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '-').replace(/^-+|-+$/g, '');
        },

        monthlyPrice() {
            return String(this.price_per_month).replace('.', ',') + ' €';
        },

        totalAmount() {
            return String(this.price).replace('.', ',') + ' €';
        },

        discountedPrice() {
            if (this.discount === 0) {
                return this.monthlyPrice;
            }
            return String(Math.ceil(this.price_per_month * (100 - this.discount)) / 100).replace('.', ',') + ' €';
        },

        discountedAmount() {
            if (this.discount === 0) {
                return this.totalAmount;
            }
            return String(Math.ceil(this.price * (100 - this.discount)) / 100).replace('.', ',') + ' €';
        },

        discount() {
            let discount_rate_voucher = 0;
            let discount_rate_interval = 0;

            if (this.voucher !== '') {
                discount_rate_voucher = this.voucher.model.discount_rate;

            }
            if (typeof (this.discounts[this.payment_interval]) !== 'undefined') {
                discount_rate_interval = this.discounts[this.payment_interval];

            }

            return discount_rate_voucher > 0 ? discount_rate_voucher : discount_rate_interval;
        },
    },

}
</script>
